import { CoursePackage } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { formatModuleLabel } from '@/utils/jtms-utils';
import {
  PackageSelection,
  ShortCourseCheckoutState
} from './short-course-checkout.types';

export const shortCourseCheckoutMutations = {
  ASSIGN_PACKAGE_SELECTIONS_FROM_COURSE_PACKAGES(
    state: ShortCourseCheckoutState,
    payload: CoursePackage[]
  ) {
    state.selectedPackages = []; // Ensure course package array is empty

    payload.forEach((coursePackage, index) => {
      let packageLabel: string = `Package ${index + 1}`;
      if (
        coursePackage.courseModules &&
        coursePackage.courseModules.length > 0
      ) {
        packageLabel = formatModuleLabel(coursePackage.courseModules);
      }

      const convertedCoursePackage: PackageSelection = {
        ...coursePackage,
        label: packageLabel,
        quantity: 0,
        isSoldOut: false
      };

      state.selectedPackages.push(convertedCoursePackage);
    });
  },

  UPDATE_PACKAGE_SELECTIONS(
    state: ShortCourseCheckoutState,
    payload: PackageSelection[]
  ) {
    state.selectedPackages = payload;
  },

  SET_IS_LAST_STEP(state: ShortCourseCheckoutState, isLastStep: boolean) {
    state.isLastStep = isLastStep;
  }
};
